import { Recipient } from '@bonusly/recipient-entities';

export const recipientsValidation = (recipients: Recipient[], directReportIds: string[]) => {
	const hasMoreThanOneRecipient = recipients.length > 1;
	const recipientIsDirectReport = recipients.every((recipient) => !!directReportIds.find((id) => id == recipient.id));
	const hasRecipients = recipients.length > 0;

	return {
		hasMoreThanOneRecipient,
		recipientIsDirectReport,
		hasRecipients,
	};
};

export const feedbackTextValidation = (feedbackText: string) => {
	return {
		hasFeedbackText: feedbackText.length > 0,
	};
};
